import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Tooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Col,
  Button,
} from 'reactstrap';
import * as Icon from 'react-feather';
import CENTROS_CON_BOTON_NOTA from './constants';

function CabeceraCiclo({
  limpio,
  horas,
  notaCiclo,
  userOU,
  documento,
  recibosPendientes,
  balance,
  tooltipBalance,
  isToolTipHoursOpened,
  isToolTipResultOpened,
  onToggle,
  onToggleHours,
  onToggleResult,
  onToggleTooltipBalance,
  onCalculateNote,
  onDownloadFile,
}) {
  const mostrarBotonNota = CENTROS_CON_BOTON_NOTA.includes(userOU?.centro);

  return (
    <div
      className="border-bottom rounded-top mb-0 py-2"
      role="button"
      tabIndex={0}
      style={{ backgroundColor: '#eef5f9', cursor: 'pointer' }}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle(e);
        }
      }}
    >
      <Container>
        <Row style={{ alignItems: 'center' }}>
          <Col xs="1">
            <Icon.Briefcase size={20} className="align-text-top" />
          </Col>
          <Col xs="6">
            <h4 style={{ margin: 0 }}>{limpio}</h4>
          </Col>
          <Col xs="1">
            <span id="toolTipHours">
              <Tooltip
                placement="top"
                isOpen={isToolTipHoursOpened}
                target="toolTipHours"
                toggle={onToggleHours}
              >
                Horas del ciclo
              </Tooltip>
              <Icon.Clock size={20} className="align-text-top" /> <b>{horas}</b>
            </span>
          </Col>
          <Col xs="1">
            <span id="toolTipResult">
              {notaCiclo !== '' ? (
                <>
                  <Tooltip
                    placement="top"
                    isOpen={isToolTipResultOpened}
                    target="toolTipResult"
                    toggle={onToggleResult}
                  >
                    Nota final
                  </Tooltip>
                  <Icon.Award size={20} className="align-text-top" /> <b>{notaCiclo}</b>
                </>
              ) : (
                ''
              )}
            </span>
          </Col>
          <Col xs="2" style={{ display: 'flex', justifyContent: 'center' }}>
            {mostrarBotonNota ? (
              <Button color="primary" onClick={onCalculateNote}>
                Calcular nota
              </Button>
            ) : (
              ''
            )}
          </Col>
          <Col xs="1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {documento.length > 0 ? (
              <>
                <UncontrolledDropdown group className="col-1 w-auto" id={3} direction="up">
                  <DropdownToggle
                    className="bg-transparent border-0 text-dark mr-2"
                    id={1}
                    onClick={(e) => e.stopPropagation && e.stopPropagation()}
                  >
                    <Icon.Download
                      size={20}
                      className="align-text-top"
                      id="Descarga"
                      color={recibosPendientes || balance < 0 ? 'red' : 'black'}
                    />
                  </DropdownToggle>
                  {/* Con recibos pendientes o balance negativo se muestra el botón
                      pero con un tooltip que explica por qué no hay descarga (en vez
                      de ocultarlo). Los recibos pendientes tienen prioridad. */}
                  {!recibosPendientes && balance >= 0 ? (
                    <DropdownMenu>
                      {documento.map((doc) => (
                        <DropdownItem id={doc.codigo} onClick={onDownloadFile} key={doc.codigo}>
                          {doc.nombre}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  ) : (
                    <Tooltip
                      placement="top"
                      isOpen={tooltipBalance.tooltipOpen}
                      target="Descarga"
                      toggle={onToggleTooltipBalance}
                    >
                      {recibosPendientes
                        ? 'Documentos no disponibles: recibos pendientes'
                        : `Documentos no disponibles: Balance negativo ${balance} €`}
                    </Tooltip>
                  )}
                </UncontrolledDropdown>
              </>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

CabeceraCiclo.propTypes = {
  limpio: PropTypes.string.isRequired,
  horas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  notaCiclo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  userOU: PropTypes.shape({ centro: PropTypes.string }),
  documento: PropTypes.arrayOf(
    PropTypes.shape({ codigo: PropTypes.string, nombre: PropTypes.string }),
  ).isRequired,
  recibosPendientes: PropTypes.bool,
  balance: PropTypes.number.isRequired,
  tooltipBalance: PropTypes.shape({ tooltipOpen: PropTypes.bool }).isRequired,
  isToolTipHoursOpened: PropTypes.bool.isRequired,
  isToolTipResultOpened: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onToggleHours: PropTypes.func.isRequired,
  onToggleResult: PropTypes.func.isRequired,
  onToggleTooltipBalance: PropTypes.func.isRequired,
  onCalculateNote: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
};

export default CabeceraCiclo;
